// extracted by mini-css-extract-plugin
export var cardIcon = "styles-module__cardIcon___lR5lj";
export var inactive = "styles-module__inactive____mnzz";